import React from "react";

const XIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
    <g clipPath="url(#a)">
      <path
        fill="#000"
        d="M15.75.938h3.067l-6.7 7.677L20 19.062h-6.171l-4.834-6.337-5.531 6.338H.395l7.166-8.213L0 .938h6.329l4.369 5.79L15.75.939Zm-1.075 16.285h1.7L5.404 2.68H3.58l11.094 14.541Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default XIcon;
